import React from "react";
import "./Loader.css";
import { useLanguage } from "LanguageContext";

const Loader = () => {
  const { t } = useLanguage();
  return (
    <div className="loader-container">
      <div className="spinner"></div>
      <p>{t("core_loader")}</p>
    </div>
  );
};

export default Loader;
